.NotificationContainer {
  --notifications-bottom-mobile: 80px;
  --notifications-bottom-desktop: 48px;

  position: fixed;
  left: 8px;
  right: 8px;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  pointer-events: none;

  &-desktop {
    bottom: var(--notifications-bottom-desktop);
  }

  &-mobile {
    bottom: var(--notifications-bottom-mobile);
  }
}

.NotificationList {
  pointer-events: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.Notification {
  pointer-events: auto;
  opacity: 0;
  transform: translateY(12px);
  transition:
    opacity 230ms cubic-bezier(0.21, 1.02, 0.73, 1),
    transform 230ms cubic-bezier(0.21, 1.02, 0.73, 1);

  .Notification-SecondaryButton {
    --btn-pad-x: 4px;
  }
}

.Notification-leave {
  opacity: 0;
  transform: translateY(20px);
}

.Notification-enter {
  opacity: 1;
  transform: translateY(0);
}
